import {
  Button,
  FlexRow,
  font,
  fontFamilies,
  fontSizes,
  Intent,
} from '@toilet-paper-games/ui';
import { observer } from 'mobx-react-lite';
import { useControllerAppModel } from '../models/ControllerAppModel';

export const SelectGameButton = observer(() => {
  const appStore = useControllerAppModel();

  return (
    <FlexRow center>
      <Button
        intent={Intent.Success}
        css={[font(fontFamilies.primary, fontSizes.lg), { marginBottom: 15 }]}
        buttonHeight={8}
        shadow
        disabled={!appStore.selectedGame}
        onClick={appStore.startGame}
      >
        Play
      </Button>
    </FlexRow>
  );
});
